import CaptainInboxes from 'dashboard/api/captain/inboxes';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'CaptainInbox',
  API: CaptainInboxes,
  actions: mutations => ({
    // Overrides the factory's create: the bulk endpoint answers with the
    // inboxes it connected plus the ones it skipped, rather than a single
    // record, so the caller can tell the user about partial success.
    create: async function create({ commit }, { assistantId, inboxIds }) {
      commit(mutations.SET_UI_FLAG, { creatingItem: true });
      try {
        const { data } = await CaptainInboxes.create({ assistantId, inboxIds });
        data.payload.forEach(inbox => commit(mutations.ADD, inbox));
        return data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { creatingItem: false });
      }
    },
    // Overrides the factory's update: the record is keyed by inbox id rather
    // than by the join row id, and the endpoint is nested under the assistant.
    update: async function update(
      { commit },
      { assistantId, inboxId, enabled }
    ) {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const { data } = await CaptainInboxes.update({
          assistantId,
          inboxId,
          enabled,
        });
        commit(mutations.EDIT, data);
        return data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
    delete: async function remove({ commit }, { inboxId, assistantId }) {
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await CaptainInboxes.delete({ inboxId, assistantId });
        commit(mutations.DELETE, inboxId);
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return inboxId;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return throwErrorMessage(error);
      }
    },
  }),
});
